import React from 'react'
const Breadcrumbs = ({ list }) => {
  return (
    <div className="breadcrumbs text-sm">
      <ul className="flex items-center gap-2">
        {list.map((item, index) => (
          <li key={index}>
            <a href={item.url} className="link link-hover">{item.label}</a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Breadcrumbs